import axios from 'axios'

// const API_URL = 'https://www.digiwallet.nl/'
const API_URL = 'https://digiwallet-site.localhost/nl/'

export default axios.create({
  baseURL: API_URL
})
